import React, { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Eraser } from "lucide-react";
import { toast } from "sonner";

const LABELS = { companies: "società", operations: "operazioni", investors: "associati", suppliers: "fornitori", accounts: "conti", movements: "movimenti", invoices: "fatture", bank_transactions: "transazioni bancarie", units: "unità" };

export default function DemoDataPanel() {
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [open, setOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const load = () => api.get("/admin/demo-data/count").then((r) => setC(r.data)).catch(() => {});
  useEffect(() => { if (user?.role === "super_admin") load(); }, [user]);
  if (user?.role !== "super_admin" || !c) return null;
  const tot = Object.values(c).reduce((a, b) => a + b, 0);
  if (tot === 0) return null;
  const purge = async () => { try { const r = await api.post("/admin/demo-data/purge", { conferma: txt }); toast.success(`Dati demo eliminati: ${Object.values(r.data.eliminati).reduce((a, b) => a + b, 0)} record`); setOpen(false); load(); } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); } };
  return (
    <Card className="p-4 border-amber-300 bg-amber-50/40" data-testid="demo-data-panel">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><div className="font-semibold flex items-center gap-2"><Eraser className="w-4 h-4" /> Dati dimostrativi ancora presenti</div><div className="text-xs text-muted-foreground">{Object.entries(c).filter(([, n]) => n).map(([k, n]) => `${n} ${LABELS[k] || k}`).join(" · ")}. Le tue società reali, utenti, impostazioni, automazioni e chiavi API non vengono toccati.</div></div>
        <Button variant="destructive" size="sm" onClick={() => { setTxt(""); setOpen(true); }} data-testid="purge-demo-btn">Svuota dati demo</Button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle className="text-destructive">Eliminare definitivamente i dati demo?</DialogTitle></DialogHeader>
          <div className="space-y-2 text-sm"><p>Verranno cancellate società, operazioni, associati, fornitori, conti, movimenti, fatture e transazioni marcati [DEMO]/TEST_ e tutto ciò che dipende da loro. Operazione irreversibile.</p><Label className="text-xs">Scrivi ELIMINA per confermare</Label><Input value={txt} onChange={(e) => setTxt(e.target.value)} data-testid="purge-confirm-input" /></div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button><Button variant="destructive" disabled={txt !== "ELIMINA"} onClick={purge} data-testid="purge-confirm-btn">Elimina</Button></DialogFooter></DialogContent>
      </Dialog>
    </Card>
  );
}
